<template>
	<el-table
		:data="orderedEvents"
		:show-header="false"
		max-height="300px">
		<el-table-column label="Date" width="130">
			<template slot-scope="scope">
				<strong class="date">
					{{ formatDate(scope.row.time || scope.row.created) }}
				</strong>
				&middot;
				{{ formatTime(scope.row.time || scope.row.created) }}
			</template>
		</el-table-column>

		<el-table-column label="Type" width="250">
			<template slot-scope="scope">
				<strong class="activity-type">{{ formatType(scope.row.type) }}</strong>
			</template>
		</el-table-column>

		<!-- Value -->
		<el-table-column label="Value" width="180">
			<template slot-scope="scope">
				<!-- {{ scope.row }} -->
			</template>
		</el-table-column>

		<!-- Details -->
		<el-table-column label="Detail">
			<template slot-scope="scope">
				&nbsp;
			</template>
		</el-table-column>
	</el-table>
</template>

<script>
import { mapGetters } from 'vuex'
import ActivityAnalysis from '.'

export default {
	name: 'patient-exercise-card-analysis-table',
	extends: ActivityAnalysis,

	props: {
		type: {
			type: String
		}
	},

	methods: {
		formatType(type) {
			var t = type.split(':')
			return this.getContentKey(t[0], t[1], 'title')
		}
	},

	computed: {
		...mapGetters('content', [
			'getContent',
			'getContentKey'
		]),
		orderedEvents() {
			return this.event.slice().sort((a, b) => (a.time - b.time))
		}
	}
}
</script>
<style lang="scss" scoped>
.activity-type {
	text-transform: capitalize;
}
</style>
